import React, { Component } from 'react'
import Toasts from '../../../components/Toast'

export default class AuthStep extends Component {
  
  getError() {
    const { isInvalid, errorMessage } = this.props

    return (
      <Toasts.SFToast 
        className={`invalid ${isInvalid && 'error'}`} 
        message={errorMessage}
        onClick={this.props.onErrorClick}
      />
    )
  }

  render() {
    const { isLoading, description, errorMessage } = this.props
    const loadingClass = isLoading ? 'loading' : ''
    return (
      <div id='auth-login'>
        <content>
          <div className='steps'>
            <div className='step'>
              <h1>{this.props.title}</h1>
              { description }
              <div className={`form ${loadingClass}`}>
                { errorMessage !=='' && this.getError() }
                { this.props.children }
              </div>
            </div>
          </div>
        </content>
      </div>
    )
  }
}

AuthStep.defaultProps = {
  onErrorClick: () => {},
  isInvalid: false,
  isLoading: false,
  errorMessage: "",
  title: "",
  description: null
}